module.exports = __webpack_public_path__ + "img/aboutus-person.fb15d5d6.png";